import React from 'react'
import Visibility from '@material-ui/icons/Visibility'

export default function VisibilityIcon() {

    return (
        <Visibility />
    )
}